import { IVehicle } from "../../interfaces/session/IVehicle";
import { validateVehicle } from "./validate-vehicle";

export function equalVehicles(v1: IVehicle, v2: IVehicle | null, checkFitmentOptions = false) {
  const validateV1 = validateVehicle(v1);
  const validateV2 = validateVehicle(v2);
  if (validateV1 !== validateV2) {
    return false;
  }

  if (!validateV1 && !validateV2) {
    return true;
  }

  const vehicle1: IVehicle = {
    make: v1.make.toLowerCase(), model: v1.model.toLowerCase(), year: v1.year, fitmentOptions: v1.fitmentOptions,
  };
  const vehicle2: IVehicle = {
    make: v2.make.toLowerCase(), model: v2.model.toLowerCase(), year: v2.year, fitmentOptions: v2.fitmentOptions,
  };
  const isEqualFO = checkFitmentOptions ? vehicle1.fitmentOptions.length === vehicle2.fitmentOptions.length
        && vehicle1.fitmentOptions.every((fo, idx) => fo.optionName.toLowerCase() === vehicle2.fitmentOptions[idx].optionName.toLowerCase()
            && fo.optionValue?.toLowerCase() === vehicle2.fitmentOptions[idx].optionValue?.toLowerCase()) : true;

  return (parseInt(vehicle1.year, 10) === parseInt(vehicle2.year, 10)
        && vehicle1.make === vehicle2.make
        && vehicle1.model === vehicle2.model
        && isEqualFO
  );
}
